import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type UpgradeAccountConnectionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpgradeManagedAccountInput;
}>;

export type UpgradeAccountConnectionMutationResult = { __typename?: 'Mutation' } & {
  upgradeManagedAccount: { __typename?: 'UpgradeManagedAccountPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpgradeAccountConnectionDocument = gql`
  mutation upgradeAccountConnection($input: UpgradeManagedAccountInput!) {
    upgradeManagedAccount(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
